import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import {
  Search, ToggleLeft, ToggleRight, Globe, Calendar, Star, Eye, ChevronRight
} from 'lucide-react';
import { STATUS_COLORS, PLAN_COLORS } from './constants';

export function TenantListView({ filtered, search, setSearch, onOpenDetail, onImpersonate, onToggle }) {
  return (
    <Card className="border-border">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-semibold text-foreground">All Tenants</CardTitle>
          <div className="relative w-64">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
              placeholder="Search by name or email..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="pl-9 h-9"
              data-testid="tenant-search"
            />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {filtered.length === 0 ? (
          <div className="text-center py-12 text-muted-foreground" data-testid="no-tenants">
            No tenants found
          </div>
        ) : (
          <div className="space-y-3">
            {filtered.map(t => (
              <div
                key={t.id}
                className="flex items-center justify-between p-4 rounded-xl border border-border hover:border-orange-200 bg-white transition-all cursor-pointer group"
                data-testid={`tenant-row-${t.id}`}
                onClick={() => onOpenDetail(t)}
              >
                <div className="flex items-center gap-4 min-w-0 flex-1">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-amber-500 flex items-center justify-center text-white font-bold text-sm shrink-0">
                    {(t.company_name || '?')[0].toUpperCase()}
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-semibold text-foreground truncate">{t.company_name}</h3>
                    <div className="flex items-center gap-3 mt-0.5 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1"><Globe className="w-3 h-3" />{t.country || 'N/A'}</span>
                      <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{new Date(t.created_at).toLocaleDateString()}</span>
                      <span>{t.email}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3 shrink-0" onClick={e => e.stopPropagation()}>
                  <div className="text-right text-xs text-muted-foreground">
                    <div>{t.user_count || 0} users</div>
                    <div>{t.branch_count || 0} branches</div>
                  </div>
                  {t.is_internal && (
                    <Badge className="bg-warning/10 text-warning border border-warning/30 text-[10px]" data-testid={`internal-badge-${t.id}`}>
                      <Star size={10} className="mr-0.5 fill-amber-500" />Internal
                    </Badge>
                  )}
                  <Badge className={PLAN_COLORS[t.plan] || 'bg-muted'}>
                    {t.is_internal ? 'Internal' : (t.plan || 'starter')}
                  </Badge>
                  <Badge className={STATUS_COLORS[t.subscription_status] || STATUS_COLORS.trial}>
                    {t.subscription_status || 'trial'}
                  </Badge>
                  <Button
                    variant="ghost" size="sm"
                    onClick={() => onImpersonate(t)}
                    className="text-muted-foreground hover:text-warning"
                    title="View as this tenant"
                    data-testid={`impersonate-${t.id}`}
                  >
                    <Eye size={16} />
                  </Button>
                  <Button
                    variant="ghost" size="sm"
                    onClick={() => onToggle(t.id, t.is_active)}
                    className={t.is_active ? 'text-success hover:text-success' : 'text-error hover:text-error'}
                    data-testid={`toggle-tenant-${t.id}`}
                  >
                    {t.is_active ? <ToggleRight className="w-5 h-5" /> : <ToggleLeft className="w-5 h-5" />}
                  </Button>
                  <ChevronRight size={16} className="text-muted-foreground group-hover:text-orange-400 transition-colors" />
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
